/** Role names and the role-management UI, shared by projects and dataspaces. */

export default {
	roles: {
		tab: "Roles",
		names: {
			viewer: "Viewer",
			editor: "Editor",
			admin: "Admin",
			member: "Member",
			owner: "Owner",
		},
		manage: {
			title: {
				project: "Project roles",
				dataspace: "Dataspace roles",
			},
			createRole: "Create role",
			editRole: "Edit role",
			duplicateRole: "Duplicate",
			duplicateName: "{name} copy",
			roleName: "Role name",
			deleteConfirm: "Delete role “{name}”?",
			deleteNote: "Members who hold it lose what it grants. This cannot be undone.",
			saved: "Saved role {name}.",
			deleted: "Deleted role {name}.",
			processCount: "{n} process | {n} processes",
			noProcesses: "No process matches.",
			permission: "Permission",
			granted: "Granted",
			notGranted: "Not granted",
			systemRole: "Built-in",
			processPicker: "Select processes…",
			sections: {
				management: "Management",
				project: "Project",
				axioms: "Axioms",
				terminology: "Terminology",
				thumbnails: "Thumbnails",
				metadata: "Metadata",
				git: "Git",
				build: "Build",
				releases: "Releases",
				dependencies: "Dependencies",
				utilities: "Utilities",
				entryPage: "Start page",
				codenames: "Code names",
				dataspace: "Dataspace",
				env: "Environment",
				telephony: "Telephony",
			},
			ops: {
				read: "Read",
				update: "Update",
				write: "Write",
				execute: "Execute",
				release: "Make releases",
				members: "Manage members",
				invitations: "Manage invitations",
				roles: "Manage roles",
				env: "Manage environment variables",
				telephony: "Manage telephony",
				processes: {
					view: "View processes",
					takePart: "Take part in processes",
					start: "Start processes",
					manage: "Manage processes",
					alias: "Name processes with an alias",
					access: "Share processes with individual people",
				},
			},
			/** The process rights of a dataspace role: what each opens, and on which processes. */
			processRights: {
				hints: {
					view: "See processes in the list, open them and follow them live. Taking part in a process includes viewing it.",
					takePart:
						"Answer questions, press buttons, change data, use the chat and close items for everyone.",
					start: "Start new processes of the chosen kinds.",
					manage: "Stop, restart, archive, delete and rename processes. Does not include taking part.",
				},
				scope: {
					none: "None",
					selected: "Selected",
					limited: "Limited",
					all: "All",
				},
				own: "Processes they started",
				ownHint: "Including the ones those processes start on their behalf.",
				cell: {
					all: "All",
					own: "Own",
					ownPlus: "Own + {n}",
				},
			},
		},
	},
};
